// extracted by mini-css-extract-plugin
export default {"container":"styles_container__HeKYy","textWrapper":"styles_textWrapper__IYa+t","link":"styles_link__TJNY5"};